/* ===========================================================
   TAILORING SERVICE — Libas e Khas
   v8: Button variant picker (Style / Size / Colour) + tailoring
   File path: assets/tailoring-service.js
   Pairs with: snippets/tailoring-service.liquid (v8)
               snippets/tailoring-option.liquid  (v8)
   NOTE: this file must contain ONLY this JavaScript.
   =========================================================== */
(function () {
  'use strict';

  function init() {
    const root = document.querySelector('[data-tailoring]');
    if (!root) return;
    if (root.__lkInit) return;
    root.__lkInit = true;

    const productForm =
      root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]:not([action*="search"]):not(.installment):not([id*="installment"])') ||
      document.querySelector('product-form form') ||
      document.querySelector('.shopify-product-form');

    if (!productForm) {
      console.warn('[Tailoring] No product form found on page.');
      return;
    }

    /* --------------------------------------------------------
       Data
       -------------------------------------------------------- */
    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-lk-variants-json]').textContent);
    } catch (err) {
      console.error('[Tailoring] Failed to parse variants JSON:', err);
    }
    const sizePos = parseInt(root.dataset.lkSizePos || '0', 10); // 1-based, 0 = no size option
    const moneyFormat = root.dataset.lkMoneyFormat || '£{{amount}}';

    const optEls = Array.from(root.querySelectorAll('[data-lk-opt]'));
    const selected = {}; // pos(1-based) -> value

    // Fixed (single value) options are always selected
    optEls.forEach(el => {
      if (el.dataset.lkFixed != null) selected[+el.dataset.lkPos] = el.dataset.lkFixed;
    });

    const isCustom     = v => /custom/i.test(v || '');
    const isUnstitched = v => /un-?stitch/i.test(v || '');

    function sizeType() {
      if (!sizePos) return 'standard';
      const v = selected[sizePos];
      if (!v) return null;
      if (isCustom(v)) return 'custom';
      if (isUnstitched(v)) return 'unstitched';
      return 'standard';
    }

    function matches(variant, sel) {
      return Object.keys(sel).every(pos => variant.options[pos - 1] === sel[pos]);
    }

    function currentVariant() {
      const totalOpts = variants.length ? variants[0].options.length : 0;
      if (Object.keys(selected).length < totalOpts) return null;
      return variants.find(v => matches(v, selected)) || null;
    }

    /* --------------------------------------------------------
       Availability: cross out values with no available combo
       -------------------------------------------------------- */
    function refreshAvailability() {
      optEls.forEach(el => {
        if (el.dataset.lkFixed != null) return;
        const pos = +el.dataset.lkPos;
        el.querySelectorAll('[data-lk-value]').forEach(btn => {
          const trial = Object.assign({}, selected, { [pos]: btn.dataset.lkValue });
          const ok = variants.some(v => v.available && matches(v, trial));
          const exists = variants.some(v => matches(v, trial));
          btn.classList.toggle('is-soldout', !ok);
          btn.disabled = !exists;
          btn.title = ok ? '' : (exists ? 'Sold out' : 'Not available in this combination');
        });
      });
    }

    /* --------------------------------------------------------
       Panels (standard / custom / unstitched)
       -------------------------------------------------------- */
    const panels = {
      standard:   root.querySelector('[data-panel="standard"]'),
      custom:     root.querySelector('[data-panel="custom"]'),
      unstitched: root.querySelector('[data-panel="unstitched"]')
    };
    function showPanel() {
      const t = sizeType();
      Object.keys(panels).forEach(k => {
        if (panels[k]) panels[k].classList.toggle('is-show', k === t);
      });
    }

    /* --------------------------------------------------------
       Price + form sync
       -------------------------------------------------------- */
    function formatMoney(cents) {
      const num = (cents / 100);
      const fmt = (d, sep) => {
        const p = num.toFixed(d).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return p.join(sep || '.');
      };
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, fmt(2, '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, fmt(0))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fmt(2, ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt(0).replace(/,/g, '.'));
    }
    function updateVisiblePrice(variant) {
      if (!variant) return;
      document.querySelectorAll(
        '.m-price__regular .m-price-item--regular, .m-price .m-price-item--regular, .m-price-item--regular'
      ).forEach(el => { el.textContent = formatMoney(variant.price); });
    }
    function syncForm(variant) {
      if (!variant) return;
      const idInput = productForm.querySelector('[name="id"]');
      if (idInput && String(idInput.value) !== String(variant.id)) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true, detail: { variantId: variant.id }
      }));
      updateVisiblePrice(variant);
    }

    /* --------------------------------------------------------
       Selecting a value
       -------------------------------------------------------- */
    function select(el, value) {
      const pos = +el.dataset.lkPos;
      selected[pos] = value;
      el.classList.remove('has-error');
      el.querySelectorAll('[data-lk-value]').forEach(b => {
        const on = b.dataset.lkValue === value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const cur = el.querySelector('[data-lk-current]');
      if (cur) cur.textContent = value;

      refreshAvailability();
      showPanel();
      syncForm(currentVariant());
    }

    optEls.forEach(el => {
      if (el.dataset.lkFixed != null) return;
      el.querySelectorAll('[data-lk-value]').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          if (btn.disabled) return;
          select(el, btn.dataset.lkValue);
        });
      });
    });

    // Pre-select first available value for non-size options (style, colour).
    // Size is left for the customer to choose on purpose.
    optEls.forEach(el => {
      if (el.dataset.lkFixed != null || +el.dataset.lkPos === sizePos) return;
      refreshAvailability();
      const first = el.querySelector('[data-lk-value]:not(.is-soldout):not([disabled])') ||
                    el.querySelector('[data-lk-value]');
      if (first) select(el, first.dataset.lkValue);
    });
    refreshAvailability();
    showPanel();

    console.log('[Tailoring] v8 ready. Variants:', variants.length,
      '| Size option:', sizePos || 'none',
      '| Custom Size:', variants.some(v => v.options.some(isCustom)) ? 'yes' : 'no');

    /* --------------------------------------------------------
       Modal open / close
       -------------------------------------------------------- */
    const modal = document.getElementById('lk-measure-modal');
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    const openBtn = root.querySelector('[data-open-measure]');
    const customOutput = root.querySelector('#lk-custom-output');

    function openModal() {
      if (!modal) return;
      modal.classList.add('lk-show');
      document.body.style.overflow = 'hidden';
      const body = modal.querySelector('.lk-modal-body');
      if (body) body.scrollTop = 0;
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('lk-show');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openModal);
    if (modal) {
      modal.querySelectorAll('[data-close-measure]').forEach(b => b.addEventListener('click', closeModal));
      modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
    }
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal && modal.classList.contains('lk-show')) closeModal();
    });

    /* --------------------------------------------------------
       Save measurements
       -------------------------------------------------------- */
    const saveBtn = modal ? modal.querySelector('[data-save-measure]') : null;
    if (saveBtn) {
      saveBtn.addEventListener('click', () => {
        const values = {};
        let filled = 0;
        modal.querySelectorAll('input[data-measure]').forEach(i => {
          const v = i.value.trim();
          if (v) { values[i.dataset.measure] = v; filled++; }
        });
        if (filled < 4) {
          alert('Please fill in at least 4 key measurements (Chest/Bust, Waist, Hips, Sleeve Length, etc.)');
          return;
        }
        const lining = modal.querySelector('input[name="lk-sleeves-lining"]:checked');
        values['Sleeves Lining'] = lining ? lining.value : 'No';
        const instr = modal.querySelector('#lk-special-instructions');
        if (instr && instr.value.trim()) values['Special Instructions'] = instr.value.trim();

        customOutput.value = Object.keys(values).map(k => k + ': ' + values[k]).join(' | ');
        openBtn.classList.add('lk-filled');
        openBtn.textContent = 'Measurements Saved — Edit';
        closeModal();
      });
    }

    /* --------------------------------------------------------
       Add-ons + instructions counter
       -------------------------------------------------------- */
    root.querySelectorAll('.lk-addon').forEach(addon => {
      addon.addEventListener('click', e => {
        e.preventDefault();
        addon.classList.toggle('lk-addon--checked');
        const cb = addon.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = addon.classList.contains('lk-addon--checked');
      });
    });
    const instrTa = modal ? modal.querySelector('#lk-special-instructions') : null;
    const instrCount = modal ? modal.querySelector('#lk-instructions-count') : null;
    if (instrTa && instrCount) {
      instrTa.addEventListener('input', () => { instrCount.textContent = instrTa.value.length; });
    }

    /* --------------------------------------------------------
       Add to Bag
       -------------------------------------------------------- */
    let isHandling = false;

    function fail(e, msg, focusEl) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (focusEl) {
        focusEl.classList.add('has-error');
        focusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (msg) alert(msg);
    }

    async function handleAddToBag(e) {
      if (isHandling) return;

      // 1. Every option chosen?
      const missing = optEls.find(el => el.dataset.lkFixed == null && !selected[+el.dataset.lkPos]);
      if (missing) {
        const name = (missing.querySelector('.lk-opt-head') || {}).textContent || 'an option';
        return fail(e, 'Please ' + name.replace('*', '').trim().toLowerCase() + '.', missing);
      }

      const variant = currentVariant() || (variants.length === 1 ? variants[0] : null);
      if (!variant) return fail(e, 'This combination is not available. Please choose another option.');
      if (!variant.available) return fail(e, 'Sorry, this option is sold out. Please choose another.');

      // 2. Tailoring details
      const type = sizeType() || 'standard';
      if (type === 'custom' && (!customOutput || !customOutput.value)) {
        return fail(e, 'Please enter your custom measurements first.', panels.custom);
      }
      if (type === 'standard') {
        const h = root.querySelector('#lk-height');
        if (h && !h.value) { fail(e, 'Please select your body height.'); h.focus(); return; }
      }

      e.preventDefault(); e.stopImmediatePropagation();
      isHandling = true;

      const btn = e.target.closest('button, [role="button"]') || e.target;
      const originalLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      const properties = {
        'Tailoring Type': type === 'custom' ? 'Custom Tailored' : (type === 'unstitched' ? 'Unstitched' : 'Standard Size')
      };
      const outfitStyleEl = document.querySelector('.lk-outfit-style__input:checked');
      if (outfitStyleEl && outfitStyleEl.value) properties['Outfit Style'] = outfitStyleEl.value;
      if (type === 'custom') {
        properties['Custom Measurements'] = customOutput.value;
      } else if (type === 'standard') {
        const h = root.querySelector('#lk-height');
        const n = root.querySelector('#lk-notes');
        if (h && h.value) properties['Body Height'] = h.value;
        if (n && n.value.trim()) properties['Length Notes'] = n.value.trim();
      }

      const qtyInput = productForm.querySelector('[name="quantity"]');
      const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value || 1, 10)) : 1;

      const items = [{ id: variant.id, quantity, properties }];
      root.querySelectorAll('.lk-addon--checked').forEach(a => {
        const vid = a.dataset.variantId;
        if (vid && vid.indexOf('REPLACE') === -1) {
          items.push({ id: parseInt(vid, 10), quantity: 1, properties: { '_addon_for': String(variant.id) } });
        }
      });

      console.log('[Tailoring] Adding items to cart:', items);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Add to bag failed');

        ['cart:refresh', 'cart:open', 'cart:added', 'ajaxProduct:added', 'product:added', 'added.cart']
          .forEach(name => document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: data })));

        if (window.Minimog && typeof window.Minimog.openCart === 'function') window.Minimog.openCart();
        if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') window.theme.cart.refresh();
        if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') window.theme.cartDrawer.open();

        setTimeout(() => {
          const drawerOpen = document.querySelector('.cart-drawer.is-open, .mini-cart.is-open, #mini-cart.show, [data-cart-drawer].open, .cart-sidebar.is-open');
          if (!drawerOpen) window.location.href = '/cart';
        }, 1200);
        if (btn) { setTimeout(() => { btn.disabled = false; btn.textContent = originalLabel; isHandling = false; }, 1500); }
      } catch (err) {
        console.error('[Tailoring] Add to bag failed:', err);
        alert('Sorry, something went wrong: ' + (err.message || 'Unknown error'));
        if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
        isHandling = false;
      }
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest(
        '[name="add"], ' +
        '.product-form__submit, .product-form__cart-submit, .product-form__add-button, ' +
        '.product-form__add-to-cart, .product-single__add-to-cart, ' +
        '.btn--add-to-cart, .btn-add-to-cart, .btn-addtocart, .add-to-cart, ' +
        '[data-add-to-cart], [data-product-add], ' +
        'button[type="submit"][form], button.button--primary[type="submit"]'
      );
      if (!btn) return;
      const btnForm = btn.form ||
                      (btn.getAttribute('form') ? document.getElementById(btn.getAttribute('form')) : null) ||
                      btn.closest('form[action*="/cart/add"]');
      if (btnForm && btnForm !== productForm) return;
      handleAddToBag(e);
    }, true);

    productForm.addEventListener('submit', handleAddToBag, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
